export enum EquipmentRelocationRequestStatusEnum{
    RequestSubmitted = 'REQUEST_SUBMITTED', // Запрос подан
    AcceptedBySportObject = 'ACCEPTED_BY_SPORT_OBJECT', // Запрос принял спортивный объект
    AcceptedByCommercialDepartment = 'ACCEPTED_NOT_RELOCATED', // Запрос одобрен, но оборудование не перемещено
    RejectedByCommercialDepartment = 'REJECTED', // Заявка отклонена или отменена
    AcceptedByAcceptanceDepartment = 'ACCEPTED_BY_ACCEPTANCE_DEPARTMENT', // Заявка утверждена отделом приемки и отправлена в транспортную службу
    RejectedByAcceptanceDepartment = 'REJECTED_BY_ACCEPTANCE_DEPARTMENT', // Заявка отклонена отделом приемки и отправлена в транспортную службу
    RelocationStarted = 'RELOCATION_STARTED', // Оборудование отправлено сотрудником, ответственным за релокацию
    Relocated = 'ACCEPTED_RELOCATED', // Оборудование перемещено
}